



































import { computed, defineComponent, ref, set, watch } from "@vue/composition-api";
import { InputPayeeInformation, PayeeInformation } from "@scrile/api-provider/dist/api/PayeeInformationProvider";
import { PayoutSystemSettings } from "@scrile/api-provider/dist/api/PayoutSystemSettingsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import { FormValues, ListFields } from "@/types";
import BaseSelect from "@/components/BaseSelect";
import BaseSpinner from "@/components/BaseSpinner";
import getComponent, { getListFields } from "./integrations";

export default defineComponent({
  name: "PayoutForm",
  components: { BaseSpinner, BaseSelect },
  setup(_, { emit }) {
    const { authUser } = useAuthUser();
    const loading = ref(false);
    const configuredPayoutSystems = ref<PayoutSystemSettings[]>([]);
    const payeeInformation = ref<PayeeInformation | null>(null);
    const values = ref<FormValues>({
      payoutSystem: "not_configured",
      currency: "not_configured",
    });
    const selectedPayoutSystem = computed(() => values.value.payoutSystem);
    const payoutSystemForm = computed(() => getComponent(selectedPayoutSystem.value).component);

    const systemList = computed<ListFields>(() =>
      getListFields().filter(
        i => !!configuredPayoutSystems.value.find(s => s.systemName === i.value && s.currencies.length > 0)
      )
    );

    const currencyList = computed(() => {
      const selectedSystem = configuredPayoutSystems.value.find(i => i.systemName === selectedPayoutSystem.value);
      return selectedSystem ? selectedSystem.currencies.map(i => ({ value: i, text: i })) : [];
    });

    const input = (newValue: string | null, field: string) => {
      set(values.value, field, newValue);
    };

    const onCurrencyList = (list: { text: string; value: string }[]) => {
      if (!list.find(i => i.value === values.value["currency"])) {
        input(list[0]?.value || "0", "currency");
      }
    };

    const systemInfoInput = (newValues: FormValues) => {
      values.value = { ...values.value, ...newValues };
    };

    const submitPayeeInfo = async () => {
      if (!authUser.value) return;
      const data: InputPayeeInformation = {
        userId: authUser.value.id,
        payoutSystem: values.value.payoutSystem || "not_configured",
        currency: values.value.currency || "not_configured",
        ...((values.value.payoutSystem !== "not_configured" && {
          [values.value.payoutSystem]: values.value[values.value.payoutSystem],
        }) ||
          {}),
      };
      payeeInformation.value = await providers.PayeeInformationProvider.update({ data });
    };

    const getData = async () => {
      try {
        loading.value = true;
        emit("setLoading", loading.value);
        const promises: Promise<any>[] = [
          providers.PayoutSystemSettingsProvider.findAll().then(r => (configuredPayoutSystems.value = r)),
        ];
        if (authUser.value)
          promises.push(
            providers.PayeeInformationProvider.find({ id: authUser.value.id }).then(r => (payeeInformation.value = r))
          );
        await Promise.all(promises);
        values.value = {
          ...values.value,
          payoutSystem: payeeInformation.value?.payoutSystem ?? "not_configured",
          currency: payeeInformation.value?.currency ?? "not_configured",
        };
      } finally {
        loading.value = false;
        emit("setLoading", loading.value);
      }
    };

    emit("setCb", () => submitPayeeInfo());
    getData();

    watch(currencyList, onCurrencyList);

    return { loading, values, payeeInformation, payoutSystemForm, systemList, currencyList, input, systemInfoInput };
  },
});
